import { traveler as travelerUtils, travelerInputs } from '@eti/utils';
import { formValueSelector } from 'redux-form';
export const getTravelerGender = (form, state, travelers) => travelers.map((_, index) => ({
  gender: formValueSelector(form)(state, travelerUtils.getTravelerFormSectionName(String(index), travelerInputs.GENDER)) || ''
}));
//# sourceMappingURL=travelerGender.js.map